import * as React from 'react';
import { Container, TextField, Button, Typography, Tooltip } from '@mui/material';
import { Login, RemoveRedEye, VisibilityOff } from '@mui/icons-material';

import styles from '../module_css/login.module.css';
import Swal from 'sweetalert2';
import imgUser from '../assets/svg/login.svg';
import CustomBackdrop from './CustomBackdrop';

import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/context/AuthProvider';
import { usePermissions } from '../hooks/usePermission';

export default function LoginContainer() {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [viewPassword , setViewPassword] = React.useState(false);
  const [openBackdrop, setOpenBackdrop] = React.useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const { isAuthenticated } = usePermissions();

  const handleViewPassword = () => setViewPassword(!viewPassword);

  React.useEffect(()=>{
    if(isAuthenticated){ //SE ENCARGA DE REDIRECCIONAR
      const origin = location.state?.from?.pathname || '/inventory';
      navigate(origin, { replace: true });
    }
  },[isAuthenticated, location, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setOpenBackdrop(true);
    const start = Date.now();
    const response = await login(username, password);
    if (response.success) { 
          Swal.fire({
          icon: "success",
          title: `BIENVENIDO`,
          text: "INICIO DE SESIÓN CORRECTO",
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true
        });
          const elapsed = Date.now() - start;
          const minTime = 1500;
          if (elapsed < minTime) await new Promise(resolve => setTimeout(resolve, minTime - elapsed));
    } else{
      Swal.fire({
        icon: "error",
        title: "CEREDENCIALES INVÁLIDAS",
        text: "VERIFICA QUE EL USUARIO Y CONTRASEÑA SEAN LOS CORRECTOS",
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });
    }

    setOpenBackdrop(false);
};


  return (
    <Container maxWidth="sm">
      <CustomBackdrop open={openBackdrop}/>
      <form className={styles.container_main_login} onSubmit={handleSubmit} style={{boxShadow: "15px 23px 11px -3px rgba(0,0,0,0.3)"}}>
        <img src={imgUser} alt="Logo" className={styles.logo_login} />
        <Typography variant="h5" gutterBottom>Iniciar Sesión</Typography>

        <TextField 
          label="NOMBRE DE USUARIO"
          variant="outlined"
          autoComplete="off"
          className={styles.textField_login}
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          inputProps={{ maxLength: 10 }}
        />

        <section>
          <TextField
            label="CONTRASEÑA"
            variant="outlined"
            autoComplete='off'
            type={viewPassword ? "text" : "password"}
            className={styles.textField_login}
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            inputProps={{ maxLength: 10 }}
          />
          <Tooltip title={viewPassword ? "OCULTAR CONTRASEÑA" : "MOSTRAR CONTRASEÑA"} placement='right-start'>
            <button type="button" className={styles.button_view_password} onClick={handleViewPassword}>
              {viewPassword ? <VisibilityOff /> : <RemoveRedEye />}
            </button>
          </Tooltip>
        </section>

        <Button
          variant="contained"
          size="large"
          endIcon={<Login />}
          className={styles.button_login}
          type="submit"
          disabled={openBackdrop}
        >
          ACCEDER
        </Button>
      </form>
    </Container>
  );
}